/** FAQ, Support, and Advertising page copy (Lithuanian). */
export const pagesMessagesLt = {
  faq: {
    pageTitle: "Dažnai užduodami klausimai",
    pageSubtitle: "Raskite atsakymus į dažniausiai užduodamus klausimus apie WasOK",
    seoTitle: "DUK — WasOK",
    seoDescription:
      "Atsakymai į dažniausiai užduodamus klausimus apie WasOK, produktų skenavimą, privatumą ir įvertinimus.",
    items: [
      {
        question: "Kaip veikia WasOK?",
        answer:
          "WasOK padeda jums prisiminti, kurie produktai jums patiko ar nepatiko, nuskaitant brūkšninius kodus ir išsaugant jūsų įvertinimus bei pastabas. Tiesiog nuskaitykite produkto brūkšninį kodą, įvertinkite jį, pridėkite pastabų, ir kitą kartą nuskaitę tą patį produktą, iškart pamatysite savo ankstesnę apžvalgą.",
      },
      {
        question: "Ar mano duomenys saugomi debesyje?",
        answer:
          "Ne! Visi jūsų duomenys saugomi vietiniu būdu jūsų įrenginyje. Mes nesinchronizuojame jūsų informacijos su debesimi, todėl jūsų pirkinių istorija ir nuomonės apie produktus lieka visiškai privačios. Tačiau tai taip pat reiškia, kad turėtumėte daryti savo įrenginio atsargines kopijas, jei norite išsaugoti savo duomenis.",
      },
      {
        question: "Ar man reikia interneto ryšio, kad galėčiau naudotis WasOK?",
        answer:
          "Ne, WasOK veikia visiškai neprisijungus. Kadangi visi jūsų duomenys saugomi vietiniu būdu jūsų įrenginyje, galite skenuoti produktus, pridėti įvertinimus ir peržiūrėti savo istoriją be jokio interneto ryšio.",
      },
      {
        question: "Ar galiu naudoti WasOK bet kokio tipo produktams?",
        answer:
          "Taip! WasOK veikia su bet kuriuo produktu, turinčiu brūkšninį kodą. Nesvarbu, ar tai maistas, kosmetika, buities prekės, elektronika ar bet kas kitas su brūkšniniu kodu, galite jį nuskaityti ir išsaugoti savo nuomonę.",
      },
      {
        question: "Kaip nuskaityti brūkšninį kodą?",
        answer:
          "Tiesiog atidarykite WasOK programėlę ir bakstelėkite skenavimo mygtuką. Nukreipkite kamerą į produkto brūkšninį kodą, ir programėlė automatiškai jį aptiks ir nuskaitys. Įsitikinkite, kad brūkšninis kodas yra gerai apšviestas ir sufokusuotas, kad gautumėte geriausius rezultatus.",
      },
      {
        question: "Ar galiu pridėti nuotraukų prie savo produktų apžvalgų?",
        answer:
          "Taip! Prie bet kurios produkto apžvalgos galite pridėti nuotraukas. Tai ypač naudinga norint prisiminti pakuotės detales, sudėties sąrašus ar bet kokią kitą vaizdinę informaciją, kuri gali padėti prisiminti, kodėl jums patiko ar nepatiko produktas.",
      },
      {
        question: "Kokią informaciją galiu išsaugoti apie produktus?",
        answer:
          "Galite išsaugoti įvertinimus (1–5 žvaigždutės), tekstines pastabas, nuotraukas, sumokėtą kainą, kur jį nusipirkote, ir individualias kategorijas. Ši išsami informacija padeda priimti pagrįstus sprendimus perkant.",
      },
      {
        question: "Ar galiu sukurti pirkinių sąrašus?",
        answer:
          "Taip! WasOK leidžia sukurti pirkinių sąrašus iš produktų, kuriuos jau įvertinote. Tai palengvina prisiminimą, kurie produktai jums patiko ir kuriuos norite nusipirkti vėl.",
      },
      {
        question: "Kaip organizuoti savo produktus?",
        answer:
          "Produktus galite organizuoti naudodami individualias kategorijas. Pavyzdžiui, galite sukurti tokias kategorijas kaip „Užkandžiai“, „Kava“, „Odos priežiūra“ ar „Valymo priemonės“. Tai palengvina apžvalgų naršymą pagal tipą.",
      },
      {
        question: "Ar WasOK nemokama?",
        answer:
          "Taip, WasOK yra visiškai nemokama atsisiųsti ir naudoti. Nėra jokių pirkinių programėlėje, prenumeratų ar paslėptų mokesčių. Manome, kad kiekvienas turėtų turėti prieigą prie privataus būdo prisiminti savo produktų pageidavimus.",
      },
      {
        question: "Ar WasOK pritaikyta prieinamumui?",
        answer:
          "WasOK sukurta taip, kad ja galėtų naudotis kuo daugiau žmonių. Programėlėje yra prieinamumo funkcijų, tokių kaip ekrano skaitytuvo palaikymas, keičiamo dydžio tekstas ir pasirenkamas didelio kontrasto režimas.",
      },
      {
        question: "Kas atsitiks, jei pašalinsiu programėlę?",
        answer:
          "Kadangi visi duomenys saugomi vietiniu būdu jūsų įrenginyje, pašalinus programėlę bus ištrintos visos jūsų produktų apžvalgos, pastabos ir pirkinių sąrašai. Prieš pašalindami programėlę, jei norite išsaugoti atsarginę kopiją, būtinai eksportuokite savo duomenis.",
      },
      {
        question: "Ar galiu eksportuoti savo duomenis?",
        answer:
          "Taip, WasOK leidžia eksportuoti savo duomenis atsarginės kopijos tikslais. Galite eksportuoti visas savo apžvalgas į failą, kurį galite išsaugoti savo įrenginyje arba pasirinktoje debesų saugykloje.",
      },
      {
        question: "Ar WasOK seka mano vietą?",
        answer:
          "Ne, WasOK neseka jūsų vietos. Nors galite rankiniu būdu įvesti parduotuvės, kurioje nusipirkote produktą, pavadinimą, programėlė nenaudoja GPS ar vietos nustatymo paslaugų.",
      },
      {
        question: "Ar galiu naudoti WasOK keliuose įrenginiuose?",
        answer:
          "Šiuo metu WasOK nesinchronizuoja duomenų tarp įrenginių, nes visi duomenys saugomi vietiniu būdu. Kiekvienas įrenginys turės savo atskirą produktų ir apžvalgų duomenų bazę.",
      },
      {
        question: "Ką daryti, jei brūkšninis kodas nesiskaitomas?",
        answer:
          "Jei brūkšninis kodas nesiskaitomas, įsitikinkite, kad jis gerai apšviestas ir sufokusuotas. Taip pat galite pabandyti nuvalyti kameros lęšį. Jei brūkšninis kodas pažeistas ar neaiškus, galbūt galėsite įvesti brūkšninio kodo numerį rankiniu būdu.",
      },
    ],
    cta: {
      heading: "Vis dar turite klausimų?",
      body: "Susisiekite su mūsų palaikymo komanda — mielai padėsime.",
      button: "Susisiekti su palaikymo komanda",
    },
  },
  support: {
    pageTitle: "Palaikymas",
    seoTitle: "Palaikymas — WasOK",
    seoDescription:
      "Gaukite pagalbą naudodami WasOK: susisiekite su palaikymo komanda, praneškite apie klaidas ir dalinkitės atsiliepimais.",
    getHelp: {
      title: "Gaukite pagalbą",
      body: "Esame čia, kad padėtume jums išnaudoti visas WasOK galimybes. Jei susiduriate su problemomis ar turite klausimų, turime keletą išteklių, galinčių jums padėti.",
    },
    faq: {
      title: "Dažnai užduodami klausimai",
      body: "Prieš susisiekdami su mumis, peržiūrėkite mūsų DUK skiltį, kurioje atsakome į dažniausius klausimus apie WasOK. Ten rasite išsamią informaciją apie tai, kaip veikia programėlė, privatumą, duomenų saugojimą ir daugiau.",
    },
    contact: {
      title: "Susisiekite su palaikymo komanda",
      body: "Jei nerandate ieškomo atsakymo, mūsų palaikymo komanda pasiruošusi padėti. Galite susisiekti su mumis šiuo adresu:",
      emailLabel: "El. paštas:",
      responseTime: "Paprastai atsakome per 24–48 valandas",
    },
    bugs: {
      title: "Pranešimas apie klaidas",
      body: "Radote klaidą? Vertiname jūsų pagalbą tobulinant WasOK. Pranešdami apie klaidą, prašome nurodyti:",
      items: [
        "Išsamų problemos aprašymą",
        "Žingsnius problemai atkurti",
        "Jūsų įrenginio modelį ir „Android“ versiją",
        "Ekrano nuotraukas ar vaizdo įrašus, jei įmanoma",
      ],
      sendPrefix: "Siųskite pranešimus apie klaidas:",
    },
    featureRequests: {
      title: "Funkcijų pasiūlymai",
      bodyBefore:
        "Turite idėją naujai funkcijai? Norėtume tai išgirsti! Siųskite savo pasiūlymus adresu",
      bodyAfter:
        ". Nors negalime įgyvendinti kiekvieno prašymo, atidžiai apsvarstome visus atsiliepimus planuodami būsimus atnaujinimus.",
    },
    knownIssues: {
      title: "Žinomos problemos",
      body: "Šiuo metu žinome apie šias problemas ir dirbame ties jų sprendimu:",
      items: [
        "Kai kurie brūkšniniai kodai gali nesiskaityti prastai apšviestose vietose — pabandykite naudoti žibintuvėlį",
        "Labai ilgų produktų pastabų išsaugojimas senesniuose įrenginiuose gali užtrukti",
        "Nuotraukų miniatiūros gali atrodyti pikselizuotos didelės skiriamosios gebos ekranuose",
      ],
    },
    appUpdates: {
      title: "Programėlės atnaujinimai",
      body: "Reguliariai išleidžiame atnaujinimus su naujomis funkcijomis, patobulinimais ir klaidų taisymais. Būtinai atnaujinkite WasOK per „Google Play“ parduotuvę, kad gautumėte naujausius patobulinimus.",
    },
    community: {
      title: "Bendruomenė",
      body: "Prisijunkite prie mūsų vartotojų bendruomenės, kurie priima protingesnius pirkimo sprendimus su WasOK. Dalinkitės patarimais, užduokite klausimus ir bendraukite su kitais vartotojais mūsų socialiniuose tinkluose.",
    },
    emergency: {
      title: "Skubi pagalba",
      body: 'Jei susiduriate su kritine problema, dėl kurios negalite naudotis programėle, prašome laiško temoje pažymėti „URGENT“, ir mes suteiksime jūsų prašymui pirmenybę.',
    },
    cta: {
      heading: "Vis dar reikia pagalbos?",
      body: "Mūsų palaikymo komanda yra čia dėl jūsų. Nedvejodami susisiekite su bet kokiais klausimais ar rūpesčiais.",
      button: "El. paštu susisiekti su palaikymo komanda",
    },
  },
  advertising: {
    pageTitle: "Reklama ir monetizacija",
    seoTitle: "Reklama — WasOK",
    seoDescription: "Kaip WasOK vertina reklamą ir monetizaciją.",
    approach: {
      title: "Mūsų požiūris",
      body: "WasOK tikime, kad jūsų pirkimo įpročiai ir nuomonės apie produktus yra privatūs ir asmeniniai. Mūsų verslo modelis atspindi šią pagrindinę vertybę.",
    },
    noAds: {
      title: "Jokių reklamų",
      body: "WasOK nerodo jokių reklamų. Mes niekada nerodysime jums reklamų, pagrįstų produktais, kuriuos skenuojate, įvertinimais, kuriuos suteikiate, ar bet kokiais kitais duomenimis, kuriuos sukuriate programėlėje. Jūsų patirtis su WasOK yra visiškai be reklamų.",
    },
    noDataSelling: {
      title: "Duomenys neparduodami",
      body: "Mes neparduodame, nenuomojame ir nesidaliname jūsų duomenimis su reklamuotojais, duomenų brokeriais ar bet kokiomis trečiosiomis šalimis. Kadangi visi jūsų duomenys saugomi vietiniu būdu jūsų įrenginyje, mes net neturime prie jų prieigos. Jūsų produktų apžvalgos, pirkinių sąrašai ir pastabos priklauso tik jums.",
    },
    noTracking: {
      title: "Jokio sekimo",
      body: "WasOK nenaudoja stebėjimo pikselių, analitikos paslaugų ar bet kokios kitos technologijos, kuri stebi jūsų elgesį ar dalinasi informacija su trečiosiomis šalimis. Mes nesekame, kokius produktus skenuojate, kuriose parduotuvėse perkate ar kaip naudojatės programėle.",
    },
    sustainability: {
      title: "Kaip išliekame tvarūs",
      body: "Galbūt jums įdomu, kaip mes išlaikome WasOK nemokamą be reklamų ar duomenų pardavimo. Mūsų požiūris yra paprastas:",
      items: [
        {
          label: "Nemokama ir atvira:",
          text: "WasOK yra nemokama visiems naudoti, be premium lygių ar mokamų sienų",
        },
        {
          label: "Racionali veikla:",
          text: "Mes išlaikome mažas išlaidas kurdami efektyvią, privatumą saugančią programinę įrangą",
        },
        {
          label: "Neprivalomos aukos:",
          text: "WasOK mylintys vartotojai gali mus paremti savanoriškomis aukomis",
        },
        {
          label: "Atvirasis kodas:",
          text: "Galime siūlyti konsultacijas ar individualaus kūrimo paslaugas organizacijoms",
        },
      ],
    },
    noAffiliate: {
      title: "Jokių partnerystės nuorodų",
      body: "WasOK nenaudoja partnerystės nuorodų ir negauna komisinių iš mažmenininkų. Kai skenuojate produktą, mes nenukreipiame jūsų pirkti jo bet kur. Programėlė skirta tik jūsų asmeniniam įrašų vedimui ir sprendimų priėmimui.",
    },
    noPromotions: {
      title: "Jokių produktų reklamavimo",
      body: "Mes nepriimame mokėjimų iš prekės ženklų ar gamintojų už jų produktų reklamavimą. WasOK niekada nesiūlys produktų, neišskirs tam tikrų prekės ženklų ir nedarys įtakos jūsų įvertinimams jokiu būdu. Jūsų nuomonės yra tik jūsų.",
    },
    partnerships: {
      title: "Trečiųjų šalių partnerystės",
      body: "WasOK nebendradarbiauja su rinkodaros įmonėmis, duomenų agregatoriais ar reklamos tinklais. Veikiame savarankiškai ir iškeliame jūsų privatumą aukščiau visko.",
    },
    future: {
      title: "Ateities planai",
      body: "Esame įsipareigoję išlaikyti WasOK be reklamų ir orientuotą į privatumą. Jei kada nors ateityje mums prireiktų įdiegti tvarų verslo modelį, mes:",
      items: [
        "Iš anksto praneštume apie bet kokius pokyčius",
        "Niekada nepakenktume privatumui ar duomenų saugumui",
        "Visada siūlytume galimybę naudotis programėle be sekimo ar reklamų",
        "Klausytumės vartotojų atsiliepimų ir rūpesčių",
      ],
    },
    supporting: {
      title: "WasOK palaikymas",
      body: "Jei mylite WasOK ir norite paremti mūsų misiją teikti privatumu grįstą pirkimo atmintį, galite:",
      items: [
        "Papasakoti draugams ir šeimai apie programėlę",
        "Palikti teigiamą atsiliepimą „Google Play“ parduotuvėje",
        "Pasidalinti savo atsiliepimais ir pasiūlymais su mumis",
        "Apsvarstyti galimybę suteikti savanorišką auką (kai bus prieinama)",
      ],
    },
    cta: {
      heading: "Turite klausimų apie mūsų politiką?",
      body: "Esame skaidrūs apie tai, kaip veikia WasOK. Jei turite klausimų apie mūsų požiūrį į privatumą, monetizaciją ar tvarumą, prašome susisiekti.",
      button: "Susisiekti su mumis",
    },
  },
};
